module.exports = __webpack_public_path__ + "img/30-Damaged.6946e378.png";